import { useEffect, useState } from "react";

import { useParams } from "react-router-dom";
import { message } from "antd";

import api from "services/api.service";

export const useCurrentContractor = () => {
  const { contractorId } = useParams();

  const [ contracts, setContracts ] = useState<any[]>([]);
  const [ contactsList, setContactsList ] = useState<any[]>([]);

  const [ activeTab, setActiveTab ] = useState<"contracts" | "contacts-list">("contracts");

  const getContracts = async () => {
    try {
      const response = await api.getContractorContracts(contractorId);

      setContracts(response.data.results);
    } catch (e) {
      message.error("Something went wrong!");
    }
  };

  const getContactsList = async () => {
    try {
      const response = await api.getContractorContactsList(contractorId);

      setContactsList(response.data);
    } catch (e) {
      message.error("Something went wrong!");
    }
  };

  const onTabChange = async (value: string) => {
    setActiveTab(value as "contracts" | "contacts-list");

    if (value === "contracts") {
      await getContracts();
    } else {
      await getContactsList();
    }
  };

  useEffect(() => {
    getContracts();
  }, []);

  return {
    activeTab,
    contracts,
    contactsList,
    getContactsList,
    onTabChange,
  };
};
